import { render, staticRenderFns } from "./GroupMirrorSheet.vue?vue&type=template&id=63494382&scoped=true"
import script from "./GroupMirrorSheet.vue?vue&type=script&lang=js"
export * from "./GroupMirrorSheet.vue?vue&type=script&lang=js"
import style0 from "./GroupMirrorSheet.vue?vue&type=style&index=0&id=63494382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63494382",
  null
  
)

export default component.exports